import type { FamilyInvite, FamilyInvitePayload, Group, GroupCategoryDraft, GroupPayload, GroupUpdatePayload, Member, MemberUpdatePayload, PublicFamilyInvite } from "../types";
import { api } from "./core";

export const groupsApi = {
  groups: () => api<Group[]>("/groups"),
  defaultGroupCategories: () => api<GroupCategoryDraft[]>("/groups/default-categories"),
  createGroup: (payload: GroupPayload) => api<Group>("/groups", { method: "POST", body: JSON.stringify(payload) }),
  updateGroup: (groupId: string, payload: GroupUpdatePayload) =>
    api<Group>(`/groups/${groupId}`, { method: "PATCH", body: JSON.stringify(payload), groupId }),
  members: (groupId: string) => api<Member[]>("/members", { groupId }),
  updateMember: (groupId: string, userId: string, payload: MemberUpdatePayload) =>
    api<Member>(`/members/${userId}`, { method: "PATCH", body: JSON.stringify(payload), groupId }),
  deleteMember: (groupId: string, userId: string) =>
    api<void>(`/members/${userId}`, { method: "DELETE", groupId }),
  invites: (groupId: string) => api<FamilyInvite[]>("/invites", { groupId }),
  invite: (code: string) => api<PublicFamilyInvite>(`/invites/${encodeURIComponent(code)}`),
  acceptInvite: (code: string) => api<Group>(`/invites/${encodeURIComponent(code)}/accept`, { method: "POST" }),
  createInvite: (groupId: string, payload: FamilyInvitePayload) =>
    api<FamilyInvite>("/invites", { method: "POST", body: JSON.stringify(payload), groupId }),
  deleteInvite: (groupId: string, inviteId: string) =>
    api<void>(`/invites/${inviteId}`, { method: "DELETE", groupId }),
};
